<template>
  <app-page title="Check Label">
    <div>
      <v-ons-list>
        <v-ons-list-header>Enter label</v-ons-list-header>
        <v-ons-list-item>
          <div class="center">
            <v-ons-input disable-auto-styling
              input-id="label"
              placeholder="Label"
              v-model="labelInput"
              @keyup.enter="lookup"
              @keyup.tab="lookup"/>
          </div>
          <div class="right">
            <v-ons-progress-circular indeterminate v-if="loading"/>
          </div>
        </v-ons-list-item>
      </v-ons-list>
      <v-ons-list v-if="!!label">
        <v-ons-list-header>Label information</v-ons-list-header>
        <v-ons-list-item>
          <div class="center label">Label</div>
          <div class="right">{{label.id}}</div>
        </v-ons-list-item>
        <v-ons-list-item>
          <div class="center label">Type</div>
          <div class="right">{{label.displayType}}</div>
        </v-ons-list-item>
        <v-ons-list-item>
          <div class="center label">Status</div>
          <div class="right"><span class="status" :class="label.status">{{label.status}}</span></div>
        </v-ons-list-item>
        <v-ons-list-item>
          <div class="center label">Battery</div>
          <div class="right">
            <v-ons-icon :icon="batteryIcon(label)"/>
          </div>
        </v-ons-list-item>
        <template v-if="label.product">
          <v-ons-list-item>
           <div class="center label">Product EAN</div>
            <div class="right">
              <router-link :to="`/product/${label.product.ean}`">{{label.product.ean}}</router-link>
            </div>
          </v-ons-list-item>
          <v-ons-list-item v-if="label.product.foreignId">
           <div class="center label">Article number</div>
            <div class="right">{{label.product.foreignId}}</div>
          </v-ons-list-item>          
          <v-ons-list-item>
            <div class="center label">Product Name</div>
            <div class="right">{{label.product.productName}}</div>
          </v-ons-list-item>
        </template>
      </v-ons-list>
      <div style="text-align: right">
        <v-ons-button v-if="label" style="margin: 0.5rem;" @click="updateLabel">
          Update
        </v-ons-button>
      </div>
    </div>
  </app-page>
</template>
<script>
import util from "../util.js";
export default {
  data: () => ({ 
    labelInput: "",
    loading: false,
    label: null,
    timer: null
  }),
  mounted() { 
    document.addEventListener("click", this.focus);
    this.focus();
    this.load();
    this.timer = setInterval(this.load, 5000);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.focus);
    clearInterval(this.timer);
  },
  watch: { "$route": "load" },
  methods: {
    focus() {
      util.focus("label");
    },

    lookup(evt) {
      evt.preventDefault();
      if (util.validateLabel(this.labelInput)) {
        this.$router.push(`/label/${this.labelInput}`);
      } else {
        util.warn(this, "Invalid label: " + this.labelInput);
      }
      this.labelInput = "";
    },

    async load() {
      const id = this.$route.params.id;
      if (!id) {
        this.loading = false;
        this.label = null;
        return;
      }
      this.loading = true;
      try {
        const label = await this.$api.getLabel(id);
        if (!!label) {
          if (label.productId) {
            label.product = 
              await this.$api.getProduct(label.productId);
          }
          if (label.locationId) {
            label.location = 
              await this.$api.getLocation(label.locationId);
          }
          this.label = label;
        } else {
          util.warn(this, `Label ${id} not found.`);
          this.$router.replace("/label");
        }
      } catch(e) {
        util.error(this, "Getting label details failed", e);
        this.$router.replace("/label");
      } finally {
        this.loading = false;
      }
    },

    batteryIcon(label) {
      return "fa-battery-" + (label.batteryStatus ? "full" : "empty");
    },

    async updateLabel() {
      await this.$api.updateLabel(this.label.id);
      this.load();
    }
  }
};
</script>

<style scoped>
.label {
  font-weight: bold;
}
.list--material {
  border-bottom: solid 1px lightgray;
}
.list-header--material {
  background: #efeff4;
  text-transform: uppercase;
  line-height: normal;
  border-bottom: solid 1px lightgray;
}
span.status {
  padding: 3px 5px 3px 5px;
  border-radius: 5px;
}
.OK {
  background: #0f0;
}
.NEW {
  background: #00f;
}
.UPDATING {
  background: #ff0;
}
.FAIL {
  background: #f00;
}

</style>



// WEBPACK FOOTER //
// src/pages/LabelPage.vue